// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"dfd2d989","143":"8a92d936","381":"7f16df0c","494":"2d0404ca","533":"2bd7a48e","682":"7b5ab320","852":"65c13933","858":"a1dfbe4b","940":"463cc46e"}[chunkId] + ".chunk.js";
};